// removed by extract-text-webpack-plugin
module.exports = {"controls":"controls__controls___2aEIi"};